import HomeTabs from '../../components/home-tabs';
import CallingApiTabContent from './home-tabs-contents/calling-api';
import ChatbotTabContent from './home-tabs-contents/chatbot';
import ClassifyTabContent from './home-tabs-contents/classify';
import CustomTabContent from './home-tabs-contents/custom';
import ExplainTabContent from './home-tabs-contents/explain';
import GenerateTabContent from './home-tabs-contents/generate';
import ParseTabContent from './home-tabs-contents/parse';
import RagaasTabContent from './home-tabs-contents/ragaas';
import SummarizeTabContent from './home-tabs-contents/summarize';
import TranslateTabContent from './home-tabs-contents/translate';

const tabs = [
	{ id: 'tab1', label: 'Summarize', content: <SummarizeTabContent /> },
	{ id: 'tab2', label: 'Generate', content: <GenerateTabContent /> },
	{ id: 'tab3', label: 'Classify/Cluster', content: <ClassifyTabContent /> },
	{ id: 'tab4', label: 'Parse/Extract', content: <ParseTabContent /> },
	{ id: 'tab5', label: 'Translate', content: <TranslateTabContent /> },
	{ id: 'tab6', label: 'Explain', content: <ExplainTabContent /> },
	{ id: 'tab7', label: 'Chatbot', content: <ChatbotTabContent />, disabled: true },
	{ id: 'tab8', label: 'Calling Api', content: <CallingApiTabContent />, disabled: true },
	{ id: 'tab9', label: 'Custom', content: <CustomTabContent /> },
	{ id: 'tab10', label: 'RAGAAS Query', content: <RagaasTabContent /> }
];

const DashboardHome: React.FC = () => {
  return (
    <div className="bg-white">
      <div className=" mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
      <h1 className="text-lg font-semibold mb-4 leading-6 text-gray-900">Gen AI Studio</h1>
        <HomeTabs tabs={tabs} />
      </div>
    </div>
  );
};

export default DashboardHome;